import React, { type FocusEvent, type MutableRefObject } from 'react';
import {
  FocusedInput,
  type TFocusedInput,
} from '@features/AvailabilityPresentation/AvailabilityPresentation.interfaces';
import { Inputs, StyledLargeTextInput } from './DateInputs.styles';

interface Props {
  checkInLabel: string;
  checkOutLabel: string;
  checkInValue: string;
  checkOutValue: string;
  placeholderText: string;
  focusedInput: TFocusedInput;
  onAction: (input: TFocusedInput) => void;
  dateInputRef: MutableRefObject<HTMLDivElement | null>;
  isDisabled?: boolean;
}

export const DateInputs = ({
  checkInLabel,
  checkOutLabel,
  checkInValue,
  checkOutValue,
  placeholderText,
  focusedInput,
  onAction,
  dateInputRef,
  isDisabled,
}: Props) => {
  const handleCheckOutClick = () => {
    if (!checkInValue) {
      onAction(FocusedInput.StartDate);
    } else {
      onAction(FocusedInput.EndDate);
    }
  };

  const handleCheckOutFocus = (event?: FocusEvent<HTMLInputElement>) => {
    if (!checkInValue) {
      event?.target.blur();
      onAction(FocusedInput.StartDate);
    } else {
      onAction(FocusedInput.EndDate);
    }
  };

  return (
    <Inputs ref={dateInputRef}>
      <StyledLargeTextInput
        id={checkInLabel}
        name={checkInLabel}
        label={checkInLabel}
        placeholderText={placeholderText}
        value={checkInValue}
        onClick={() => onAction(FocusedInput.StartDate)}
        onFocus={() => onAction(FocusedInput.StartDate)}
        hasExternalFocus={focusedInput === FocusedInput.StartDate}
        isReadOnly={true}
        straightCorners="right"
        removeBorder={focusedInput === FocusedInput.EndDate ? 'right' : undefined}
        isDisabled={isDisabled}
      />
      <StyledLargeTextInput
        id={checkOutLabel}
        name={checkOutLabel}
        label={checkOutLabel}
        placeholderText={placeholderText}
        value={checkOutValue}
        onClick={handleCheckOutClick}
        onFocus={handleCheckOutFocus}
        hasExternalFocus={focusedInput === FocusedInput.EndDate}
        isReadOnly={true}
        straightCorners="left"
        removeBorder={focusedInput !== FocusedInput.EndDate ? 'left' : undefined}
        isDisabled={isDisabled}
      />
    </Inputs>
  );
};
